import './polyfills';
import 'whatwg-fetch';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AccountPanelAppModule } from './app.module';
import { prodConfig } from './blocks/config/prod.config';
import { AppConfiguration } from './core/models/app-configuration.model';

prodConfig();
// @ts-ignore
if (module['hot']) {
  // @ts-ignore
  module['hot'].accept();
}

export function fetchConfig(): Promise<AppConfiguration> {
  return window.fetch('/content/configuration/config.json')
    .then(response => response.json())
    .then(response => {
      if (response && !response.authConfig.redirectUri) {
        response.authConfig.redirectUri = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
      }
      return new AppConfiguration(response);
    });
}

fetchConfig().then(config => {
  platformBrowserDynamic([
    { provide: AppConfiguration, useValue: config }])
    .bootstrapModule(AccountPanelAppModule)
    // eslint-disable-next-line no-console
    .then(() => console.log('Application started')) // NOSONAR
    .catch(err => console.error(err)); // NOSONAR
});
